import { CardContent } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import { NumberInput } from '@/components/ui/number-input'
import { CompactToggle } from '@/components/ui/toggle-setting'
import PlanCardShell from '@/components/plan/PlanCardShell'

function ProfitSharingConditionsControl({ idPrefix, conditions = {}, onChange, disabled }) {
  const minHours = conditions.minHours ?? 0
  const lastDayRequired = conditions.lastDayRequired === true
  return (
    <div className="rounded-md border border-border/60 bg-muted/20 p-3 space-y-2">
      <p className="text-sm font-medium">Allocation conditions (profit sharing only)</p>
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2">
          <Label htmlFor={`${idPrefix}-ps-min-hours`} className="text-sm text-muted-foreground">Minimum hours</Label>
          <NumberInput
            id={`${idPrefix}-ps-min-hours`}
            value={minHours}
            onValueChange={(value) => onChange?.({ minHours: Math.max(0, Math.round(Number(value) || 0)) })}
            min={0}
            max={2080}
            integer
            disabled={disabled}
            emptyValue={0}
            className="h-8 w-24"
          />
        </div>
        <label className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={lastDayRequired}
            disabled={disabled}
            onChange={(event) => onChange?.({ lastDayRequired: event.target.checked })}
            className="h-4 w-4 rounded border-input"
          />
          <span className="text-muted-foreground">Employed on the last day of the plan year</span>
        </label>
      </div>
      <p className="text-xs text-muted-foreground">
        Participants who miss these conditions receive no profit sharing and drop out of the
        minimum-allocation gateway population. Leave hours at 0 and the box unchecked for no condition.
      </p>
    </div>
  )
}

// Profit sharing, as its own top-level plan card: the enable toggle, the guided
// designer (passed in as `designer` so this file stays free of formula logic),
// and the allocation conditions that apply to profit sharing only.
export default function ProfitSharingCard({
  id,
  title,
  description,
  contributions,
  reference,
  designer = null,
  onPsEnabledChange,
  onPsConditionsChange,
  disabled,
  variant,
}) {
  const { profitSharing = {} } = contributions
  const enabled = profitSharing.enabled === true

  return (
    <PlanCardShell
      id={id}
      disabled={disabled}
      variant={variant}
      title={title}
      description={description}
      titleAction={() => onPsEnabledChange(!enabled)}
      titleActionLabel="Toggle profit sharing"
      titleActionDisabled={disabled}
      headerAction={<CompactToggle label="Include profit sharing in plan" checked={enabled} onCheckedChange={onPsEnabledChange} disabled={disabled} />}
      collapsible={false}
    >
      {(reference || enabled) && <CardContent className="space-y-3">
        {reference}
        {enabled && (
          <>
            {designer}
            <ProfitSharingConditionsControl
              idPrefix={id}
              conditions={profitSharing.conditions || {}}
              onChange={onPsConditionsChange}
              disabled={disabled}
            />
          </>
        )}
      </CardContent>}
    </PlanCardShell>
  )
}
